module.exports = __webpack_public_path__ + "img/program2.dd60b497.png";